"use client";

import { CheckIcon, ChevronLeftIcon, InfoIcon } from "@chakra-ui/icons";
import { Box, Button, Flex, Heading, Link, Text } from "@chakra-ui/react";
import RouterLink from "next/link";
import { ContentfulImage } from "../../../components/ContentfulImage";
import { getRichTextRenderFunction } from "../../../utils/renderRichText";
import { NotFoundComponent } from "../../not-found-component";

import type { ContentEvent } from "../../content";

const renderRichText = getRichTextRenderFunction(4);

type Props = {
  event: ContentEvent | null;
};

export function PageComponent(props: Props) {
  const { event } = props;
  return event ? (
    <>
      <Heading mb={4}>{event.title}</Heading>
      <Link as={RouterLink} href="/termine" color="blue.500">
        <ChevronLeftIcon />
        zur Übersicht
      </Link>
      {event.hasEnrol && event.status === "open" ? (
        <Flex p={4} alignItems="center" rounded="md" bg="green.200" mt={4}>
          <CheckIcon />
          <Flex
            ml={4}
            flexDirection={["column", "row"]}
            alignItems="center"
            justifyContent="space-between"
            flexGrow="1"
          >
            <Text>
              Für dieses Event kannst du dich ganz einfach online anmelden!
            </Text>
            <Button
              as={RouterLink}
              href={`/anmeldung/${event.id}`}
              colorScheme="green"
              ml={[0, 4]}
              mt={[1, 0]}
              flexShrink="0"
            >
              zur Anmeldung
            </Button>
          </Flex>
        </Flex>
      ) : null}
      {event.hasEnrol && event.status === "limit reached" ? (
        <Flex p={4} alignItems="center" rounded="md" bg="yellow.200" mt={4}>
          <InfoIcon />
          <Text ml={4}>
            Das Limit für die Anzahl der Anmeldungen ist schon erreicht. Die
            Online-Anmeldung ist daher leider nicht mehr möglich.
          </Text>
        </Flex>
      ) : null}
      {event.status === "canceled" ? (
        <Flex p={4} alignItems="center" rounded="md" bg="yellow.200" mt={4}>
          <InfoIcon />
          <Text ml={4}>
            Wir müssen die Veranstaltung auf Grund zu geringer Teilnehmeranzahl
            leider absagen.
          </Text>
        </Flex>
      ) : null}
      {event.imageUrl ? (
        <Box rounded="lg" mt={4} overflow="hidden">
          <ContentfulImage
            src={event.imageUrl}
            alt={event.title}
            height={200}
            width={300}
            style={{ width: "100%" }}
          />
        </Box>
      ) : null}
      {renderRichText(event.description)}
    </>
  ) : (
    <NotFoundComponent />
  );
}
